export default __webpack_public_path__ + "static/media/gallery_12.01898a77.jpg";